// components/ArticleNotFound.jsx
import { Link } from 'react-router-dom';

const ArticleNotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full text-center">
        {/* Icono */}
        <div className="mb-8">
          <div className="w-32 h-32 mx-auto bg-[#5cba3c] rounded-full flex items-center justify-center">
            <svg
              className="w-16 h-16 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8c0 1.703-.528 3.281-1.43 4.577"
              />
            </svg>
          </div>
        </div>

        {/* Texto Principal */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Artículo No Encontrado
        </h1>

        <p className="text-gray-600 mb-8 text-lg">
          Lo sentimos, el artículo que buscas no existe o ha sido removido.
        </p>

        {/* Botones de Acción */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-[#5cba3c] text-white font-semibold rounded-lg hover:bg-[#47bb21] transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Volver al Inicio
          </Link>

          <Link
            to="/category/empaque-y-logistica"
            className="inline-flex items-center px-6 py-3 bg-white text-[#5cba3c] border border-[#5cba3c] font-semibold rounded-lg hover:bg-[#5cba3c] hover:text-white transition-all duration-300"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              />
            </svg>
            Ver Artículos
          </Link>
        </div>

        {/* Categorías Sugeridas */}
        <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Explora nuestras categorías
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <Link
              to="/category/empaque-y-logistica"
              className="p-3 bg-gray-50 hover:bg-[#5cba3c] hover:text-white text-gray-700 rounded-md transition-colors duration-200 text-sm font-medium"
            >
              Empaque y Logística
            </Link>
            <Link
              to="/category/suministros-institucionales"
              className="p-3 bg-gray-50 hover:bg-[#5cba3c] hover:text-white text-gray-700 rounded-md transition-colors duration-200 text-sm font-medium"
            >
              Suministros Institucionales
            </Link>
            <Link
              to="/category/glosario-y-formacion"
              className="p-3 bg-gray-50 hover:bg-[#5cba3c] hover:text-white text-gray-700 rounded-md transition-colors duration-200 text-sm font-medium"
            >
              Glosario y Formación
            </Link>
            <Link
              to="/search"
              className="p-3 bg-gray-50 hover:bg-[#5cba3c] hover:text-white text-gray-700 rounded-md transition-colors duration-200 text-sm font-medium"
            >
              Buscar Artículos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleNotFound;
